<template>
  <grid :elements="gridElements" :layout="layout" :vertical-alignment="filterElement.vertical_alignment">
    <template #element="slotProps">
      <list-view-filter-grid-element
        :filter-element="slotProps.element"
        :class="slotProps.classes"
        :key="slotProps.index"
      ></list-view-filter-grid-element>
    </template>
    <template #empty="slotProps">
      <div
        :class="slotProps.classes"
        :key="slotProps.index"
      ></div>
    </template>
  </grid>
</template>

<script lang="ts">
  import Vue from "vue";
  import filterElementBaseMixin from "../../../common/mixins/listViews/filterElementBaseMixin";
  import ListViewFilterElement from "../../../common/models/listViews/elements/listViewFilterElement";
  import ListViewFilterGridElement from "./list-view-filter-grid-element.vue"
  import Grid from "../../../common/components/layouts/grid.vue";

  export default Vue.extend({
    components: {
      ListViewFilterGridElement,
      Grid,
    },
    mixins: [
      filterElementBaseMixin,
    ],
    data: function () {
      return {};
    },
    computed: {
      gridElements(): ListViewFilterElement[] {
        return this.filterElement.filterElementsArray.reduce((array, ce) => {
          array[ce.sort_order] = ce
          return array
        }, [])
      },
      layout(): number[] {
        return this.filterElement.layout_config?.map(c => parseFloat(c)) || [1]
      },
    },
  });
</script>